module.exports = __webpack_public_path__ + "img/03.03e1debf.gif";